import StarsRating from "@/app/components/atomic/StarsRating";
import React from "react";
import IReview from "@/@types/health/review";

const ReviewCard = ({ review }: { review: IReview }) => (
    <div
        className="bg-white rounded-rm-10 border border-blue-200 p-rm-20 flex flex-col
        justify-between h-full gap-rm-25"
    >
        <div className="text-rm-12 text-blue-900 font-light">
            <blockquote>« {review.comment} »</blockquote>
        </div>

        <div className="w-full flex justify-between items-center">
            <div className="text-rm-10 text-blue-900">
                <span className="font-semibold">{review.reviewerName}</span>
                <span>・{review.date}</span>
            </div>
            <div className="inline-flex items-center justify-center gap-1">
                <span className="text-rm-10 text-blue-900 rm-lg:hidden rm-xl:block">{review.provider}</span>
                <StarsRating
                    notation={review.stars}
                    starsFontSize="text-rm-10"
                    gap={'gap-0'}
                />
            </div>
        </div>
    </div>
)

export default ReviewCard;